// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__35XiZ","info":"UpdateTermsInfo_info__1AhcZ"};